<section class="pt-6 pb-12" id="auction" *transloco="let t; prefix: 'property-details.auction-section'">
  <h2 class="text-[1.75rem] font-semibold text-black pb-6">
    {{t('auction-rounds')}}
  </h2>
  <div class="flex flex-col gap-y-4 lg:gap-y-10 w-full">
    <div class="w-full max-w-[600px]">
      <div class="p-1 border-full border border-gray-500 lg:flex flex-row rounded-full hidden">
        @for (round of model.auctionRounds?.rounds; track round.roundNumber) {
        <button class="tab-pill flex-1 justify-center" type="button"
          [ngClass]="{ active: round.roundNumber === activeRound$.value  }"
          (click)="setActiveRound(round.roundNumber ?? 1)">
          {{t('round-'+round.roundNumber)}}
        </button>
        }
      </div>
      <div class="block lg:hidden">
        <div (clickOutside)="isDropdownOpen = false" class="transition-all relative">
          <div class="flex flex-col gap-1 min-w-[115px]">
            <button (click)="isDropdownOpen = !isDropdownOpen"
              class="flex items-center justify-between text-sm py-2 px-3 btn-secondary text-black max-w-[300px]">
              {{activeRound$.value}}ος γύρος
              <i class="ml-3 text-lg active:text-primary-700"
                [ngClass]="isDropdownOpen ? 'icon-chevron-down' : 'icon-chevron-up'">
              </i>
            </button>
          </div>
          @if (isDropdownOpen) {
          <div
            class="absolute top-[100%] translate-y-4 left-0 rounded-xl shadow-2xl bg-gray-50 z-50 max-h-[300px] overflow-y-auto overflow-x-hidden w-[300px]">
            @for (round of model.auctionRounds?.rounds; track round.roundNumber; let i = $index) {
            <label role="button" [attr.for]="'menu-item-' + i" class="menu-item-checkbox small pb-2">
              <input type="checkbox" class="hidden" [attr.id]="'menu-item-'+i" name="menu-item-radio-group1"
                (change)="setActiveRound(round.roundNumber ?? 1); isDropdownOpen = false"
                [checked]="activeRound$.value === round.roundNumber">
              <div class="menu-item-content p-4"
                [ngClass]="{'bg-gray-100 rounded': activeRound$.value === round.roundNumber}">
                <div class="flex flex-row justify-between">
                  <span class="menu-item-radio-text text-sm text-black"
                    [ngClass]="{'text-primary-700': activeRound$.value === round.roundNumber}">{{t('round-'+round.roundNumber)}}</span>
                </div>
              </div>
            </label>
            }
          </div>
          }
        </div>
      </div>
    </div>
    @for (round of model.auctionRounds?.rounds; track round.roundNumber; let last = $last) {
    @if (activeRound$.value === round.roundNumber) {
    <div class="border-gray-300 border rounded-xl bg-white overflow-hidden mb-6">
      <div class="p-6 flex justify-between items-start md:flex-row flex-col gap-4">
        <div>
          <div class="flex gap-3 mb-2">
            <h5 class="text-xl text-black ">{{t('round-'+round.roundNumber)}}</h5>
            @if (last) {
            <div class="py-1 px-2 rounded-full bg-[#2569D4] text-white text-[0.625rem] leading-loose whitespace-nowrap">
              {{t('current-round')}}</div>
            }
          </div>
          <p class="text-gray-900">{{t('auction-date')}}: <span class="text-black">{{round.roundDate| date: locale ==
              'el' ? 'dd MMMM, YYYY' : 'MMMM
              dd, YYYY' : '' : locale}}</span></p>
        </div>
        <a [href]="model.auctionRounds?.auctionLink" target="_blank" class="btn-text flex items-center">
          <span style="text-decoration: none">{{t('view-auction')}}</span>
          <i class="icon-arrow-right"></i>
        </a>
      </div>

      <div class="p-6 bg-[#F5F9FB] flex-col">
        <div class=" flex">
          <p class="text-gray-900 flex-1">{{t('start-price')}}: <span class="text-black">€{{round.startingPrice |
              currency:
              'EUR' : '' : '1.0-0'}}</span></p>
          <p class="text-gray-900 flex-1">{{t('price-per-sq')}} <span class="text-black">€{{round.pricePerSquareMeter |
              currency:
              'EUR': '' : '1.0-0'}}</span></p>
        </div>
        @if(discount > 0)
        {
        <div class="discount-label">
          <span class="discount-percentage">-{{ this.discount}}%</span>
          <span class="discount-text">{{t('from-base-price')}}</span>
        </div>
        }
      </div>
    </div>
    }}
  </div>
  <!-- Hidden bidding support button so that we hide the bidding support for now #45953-->
  <div class="rounded-xl bg-[#EFFEFC] border border-[#0BC1C0] p-4">
    <div class="flex md:flex-row flex-col justify-between gap-4">
      <div class="flex items-start gap-4">
        <img class="md:order-1 order-2" src="./assets/lightbulb.png">
        <p class="text-gray-950 text-sm md:order-2 order-1">{{t('auction-info')}} </p>
      </div>
      <button [localizedRouterLink]="['/services/biddingSupport']" [queryParams]="{ property: model.code}"
        class="btn-secondary text-nowrap text-sm pl-4 pr-4 max-w-[155px]">
        {{t('learn-more')}}
      </button>
    </div>
  </div>
  <section class="pt-6 pb-12" *ngIf="hasRelatedAuction" id="relevant-auctions">
    <h2 class="text-[1.75rem] font-semibold text-black pb-6">
      {{t('related-auctions')}}
    </h2>
    <div class="flex flex-col gap-y-4 lg:gap-y-6 w-full bg-gray-50  p-6 rounded-xl">
      <div *ngFor="let related  of model.auctionRounds?.relatedAuctions"
        class="flex justify-between items-center py-4 bg-white rounded-lg hover:shadow-md">
        <div class="flex gap-x-4 pl-4 items-center">
          <span class="text-gray-500">{{related.type}}</span>
          <span class="text-black font-medium">{{related.code}}</span>
        </div>
        <div class="flex gap-x-4 items-center pr-4 justify-end">
          <div class="text-lg font-semibold text-black">
            {{related.price | currency: 'EUR'}}
          </div>
          @if (related.url !== undefined) {
          <a class="icon-arrow-right text-gray-400 hover:text-primary cursor-pointer"
            [localizedRouterLink]="[related.url]"></a>
          }
          @else {
          <a></a>
          }
        </div>
      </div>
    </div>
  </section>
</section>